import type { BanScope, DerivedPermissionFlags } from '@mrb91002/shared-types'

/**
 * True when the given action is restricted for the user. Treats `all` as covering
 * every restrictable scope. Accepts the raw `DerivedPermissionFlags` shape returned
 * by the secure profile endpoint.
 *
 * UX convenience only — the authoritative enforcement is the backend ban check.
 */
export function isActionRestricted(
  flags: Pick<DerivedPermissionFlags, 'restricted_actions' | 'is_restricted'> | null | undefined,
  scope: BanScope,
): boolean {
  if (!flags || !flags.is_restricted) return false
  return flags.restricted_actions.includes('all') || flags.restricted_actions.includes(scope)
}

/**
 * Convenience overload working directly off the `restrictedActions` array exposed by
 * `useAuth()`. Treats `all` as covering every restrictable scope.
 *
 * UX convenience only — the authoritative enforcement is the backend ban check.
 */
export function isScopeRestricted(restrictedActions: BanScope[], scope: BanScope): boolean {
  return restrictedActions.includes('all') || restrictedActions.includes(scope)
}
